<template>
  <div class="allbox">
    <div class="top_inrwe">
      <div class="condition">
        <el-input
          v-model="query.name"
          class="inptw"
          placeholder="请输入投放规则名称"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="list"
        >搜索</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="insert"
        >新增</el-button>
      </div>
    </div>
    <el-table
      :data="inter_put_datalist"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="id"
      />
      <el-table-column
        prop="name"
        label="投放规则名称"
      />
      <el-table-column
        label="图片和视频拒审比例"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.material_reject_examine_proportion">{{ scope.row.material_reject_examine_proportion }}%</span>
        </template>
      </el-table-column>
      <el-table-column
        label="文本拒审比例"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.text_reject_examine_proportion">{{ scope.row.text_reject_examine_proportion }}%</span>
        </template>
      </el-table-column>
      <el-table-column
        label="原生页拒审比例"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.url_reject_examine_proportion">{{ scope.row.url_reject_examine_proportion }}%</span>
        </template>
      </el-table-column>
      <el-table-column label="关键字">
        <template slot-scope="scope">
          <el-tag v-for="item,index in scope.row.key_words" :key="index">{{ item }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="创建时间"
      />
      <el-table-column
        label="是否拒审更新重审"
        width="80"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_fail_correction === 1" type="success">开启</el-tag>
          <el-tag v-else type="danger">关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="300px"
      >
        <template scope="scope">
          <el-button type="primary" size="mini" @click="bindAccount(scope.row)">查看绑定账户</el-button>
          <el-button type="warning" size="mini" icon="el-icon-edit" @click="edit(scope.row)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="type ? '创建' : '修改'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      style="min-width:680px"
      @closed="editInfo = {}"
    >
      <inter-put-info v-if="dialogVisible" ref="details" :drawer-item="editInfo" @determine="commitInter" />
    </el-dialog>
    <el-dialog
      title="绑定列表"
      :visible.sync="bind_visible"
      :close-on-click-modal="false"
    >
      <bind-account :id="bind_id" />
    </el-dialog>
  </div>
</template>

<script>

import PaginationRight from '@/components/PaginationRight/index.vue'
import { InterPutRuleDelete, InterPutRuleInsert, InterPutRuleList, InterPutRuleUpdate } from '@/api/customer'
import InterPutInfo from '@/views/tencentAD/IntPut/components/interPutInfo.vue'
import BindAccount from '@/views/tencentAD/IntPut/components/bindAccount.vue'

export default {
  components: { BindAccount, InterPutInfo, PaginationRight },
  data() {
    return {
      inter_put_datalist: [],
      total: 0,
      query: {
        sub_uc_name: null,
        page: 1,
        pageSize: 10,
        sub_uc_id: null
      },
      dialogVisible: false,
      type: false,
      editInfo: null,
      bind_visible: false,
      bind_id: null
    }
  },
  computed: {
  },
  created() {
    this.list()
  },
  methods: {
    list() {
      InterPutRuleList(this.query).then(res => {
        this.inter_put_datalist = res.data.list
        console.log(this.baidudataList)
        this.total = res.data.total
      })
    },
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    commitInter(val) {
      if (this.type) {
        InterPutRuleInsert(val).then(res => {
          if (res.code === 0) {
            this.$message.success('新增成功')
            this.dialogVisible = false
            this.list()
          }
        })
      } else {
        // 修改
        InterPutRuleUpdate(val).then(res => {
          if (res.code === 0) {
            this.$message.success('修改成功')
            this.dialogVisible = false
            this.list()
          }
        })
      }
    },
    insert() {
      this.editInfo = []
      this.type = true
      this.dialogVisible = true
    },
    del(val) {
      this.$confirm('确定要删除当前规则吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        InterPutRuleDelete({
          id: val.id
        }).then((res) => {
          if (res.code === 0) {
            this.$message.success('删除成功')
            this.list()
          }
        })
      })
    },
    edit(val) {
      this.editId = val.id
      this.type = false
      this.dialogVisible = true
      this.editInfo = val
    },
    bindAccount(val) {
      console.log(val)
      this.bind_id = val.id
      this.bind_visible = true
    }
  }
}
</script>

<style scoped>
.allbox {
  padding: 30px;
}

.top_inrwe {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inptw {
  width: 250px;
}

.condition > * {
  margin-right: 10px;
}
</style>
